import { render } from "./AppReact.vue?vue&type=template&id=0ae86e0e"
import script from "./AppReact.vue?vue&type=script&lang=js"
export * from "./AppReact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__